<mat-expansion-panel>
  <mat-expansion-panel-header>
    <mat-panel-title>{{
      translationService.getLocationText()
    }}</mat-panel-title>
    <mat-panel-description>{{ currentLocation }}</mat-panel-description>
  </mat-expansion-panel-header>
  <button (click)="locationService.showLocationDialog(dialog)">
    {{ translationService.getChangeLocationText() }}
  </button>
</mat-expansion-panel>
